'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _ = require('lodash');
var FaresOptimizerCSVExportService = function FaresOptimizerCSVExportService($filter, fileSaveService, app, faresOptimizerConstants, momentService, momentConstants) {
  var rmMomentFormat = $filter('rmMomentFormat');

  // Header metadata definitions
  var headerMetadataMap = {
    STRUCTURAL: getStructuralHeaderMetadata(),
    TACTICAL: getTacticalHeaderMetadata(),
    ADAPTIVE: getAdaptiveHeaderMetadata()
  };

  // Data row generator map
  var dataRowGenerators = {
    STRUCTURAL: getStructuralDataRow,
    TACTICAL: getTacticalDataRow,
    ADAPTIVE: getAdaptiveDataRow
  };

  /**
   * Main export function for regular CSV format
   */
  function exportToCSVFormat(data, type, recommendationLevel) {
    var headerRows = getHeaderRows(recommendationLevel);
    var dataRows = getDataRows(data, recommendationLevel);
    var allRows = _.concat(headerRows, dataRows);
    fileSaveService.createFile(getFileDataFromRows(allRows), 'text/csv;charset=utf-8', getFilePrefix(type, data[0].market) + '.csv');
  }

  /**
   * Get header metadata based on recommendation level
   */
  function getHeaderMetadata(recommendationLevel) {
    return headerMetadataMap[recommendationLevel] || headerMetadataMap.ADAPTIVE;
  }

  /**
   * Generate header rows from metadata
   */
  function getHeaderRows(recommendationLevel) {
    var headerMetadata = getHeaderMetadata(recommendationLevel);
    return [_.map(headerMetadata, 'label')];
  }

  /**
   * Generate data rows from raw data
   */
  function getDataRows(data, recommendationLevel) {
    var dataRows = [];
    _.forEach(data, function (rowData) {
      var rowGroups = getUnexpiredRecommendations(rowData.rowGroups);
      _.forEach(rowGroups, function (rowGroupData) {
        _.forEach(rowGroupData.groupedRows, function (groupedRowData) {
          dataRows.push(getDataRow(rowData, groupedRowData, recommendationLevel));
        });
      });
    });
    return dataRows;
  }

  /**
   * Filter out expired recommendations
   */
  function getUnexpiredRecommendations(rowGroups) {
    return _.filter(rowGroups, function (rowGroup) {
      return !rowGroup.isExpired;
    });
  }

  /**
   * Get appropriate data row based on recommendation level
   */
  function getDataRow(rowData, groupedRowData, recommendationLevel) {
    var generator = dataRowGenerators[recommendationLevel] || dataRowGenerators.ADAPTIVE;
    return generator(rowData, groupedRowData);
  }

  /**
   * Generate structural data row
   */
  function getStructuralDataRow(rowData, groupedRowData) {
    var compFare = _.includes(groupedRowData.compFare, '&nbsp;') ? _.replace(groupedRowData.compFare, '&nbsp;', ' ') : groupedRowData.compFare;
    return [groupedRowData.hostCarrier, rowData.market, rowData.cabin, groupedRowData.tariffNumber, groupedRowData.season, groupedRowData.dow, groupedRowData.tripType, groupedRowData.fbc, groupedRowData.fareBrandName, rmMomentFormat(groupedRowData.effectiveDate, 'DATE_ISO'), rmMomentFormat(groupedRowData.discontinueDate, 'DATE_ISO'), groupedRowData.advancePurchase, ' ' + groupedRowData.apGroup + ' ', groupedRowData.minStays, groupedRowData.maxStay, groupedRowData.routingNumber, groupedRowData.footnote, groupedRowData.constructionMethod, groupedRowData.currencyCode, groupedRowData.currentFareTotal, groupedRowData.recommendedFareTotal, groupedRowData.fareChangeAbsolute, Math.round(groupedRowData.fareChangePercentage * 100), groupedRowData.effectiveFareChangeAbsolute, groupedRowData.currentFareBase, groupedRowData.recommendedFareBase, groupedRowData.distributedFare, groupedRowData.compFareSource, groupedRowData.compCarrier, groupedRowData.compTariffNumber, groupedRowData.compTripType, groupedRowData.compMarketFbc, groupedRowData.compFareBrandName, compFare, groupedRowData.compRoutingNumber, groupedRowData.compFootnote, groupedRowData.status, groupedRowData.lastUpdated, getRecommendationReasons(groupedRowData.ladderRemarks), getNoRecommendationReasons(groupedRowData.ladderRemarks), getStopAutoApprovalReasons(groupedRowData.autoApprovalStoppedReasonsFilterKeys)];
  }

  /**
   * Generate tactical data row
   */
  function getTacticalDataRow(rowData, groupedRowData) {
    var compFare = _.includes(groupedRowData.compFare, '&nbsp;') ? _.replace(groupedRowData.compFare, '&nbsp;', ' ') : groupedRowData.compFare;
    return [groupedRowData.hostCarrier, rowData.market, rowData.cabin, groupedRowData.tariffNumber, groupedRowData.season, groupedRowData.dow, groupedRowData.tripType, groupedRowData.fbc, groupedRowData.fareBrandName, rmMomentFormat(groupedRowData.effectiveDate, 'DATE_ISO'), rmMomentFormat(groupedRowData.discontinueDate, 'DATE_ISO'), groupedRowData.advancePurchase, ' ' + groupedRowData.apGroup + ' ', groupedRowData.minStays, groupedRowData.maxStay, groupedRowData.routingNumber, groupedRowData.footnote, groupedRowData.constructionMethod, rmMomentFormat(groupedRowData.firstTicketDate, 'DATE_ISO'), rmMomentFormat(groupedRowData.lastTicketDate, 'DATE_ISO'), rmMomentFormat(groupedRowData.travelFromDate, 'DATE_ISO'), rmMomentFormat(groupedRowData.travelToDate, 'DATE_ISO'), rmMomentFormat(groupedRowData.travelCompleteDate, 'DATE_ISO'), groupedRowData.currencyCode, groupedRowData.currentFareTotal, groupedRowData.recommendedFareTotal, groupedRowData.fareChangeAbsolute, Math.round(groupedRowData.fareChangePercentage * 100), groupedRowData.effectiveFareChangeAbsolute, groupedRowData.currentFareBase, groupedRowData.recommendedFareBase, groupedRowData.distributedFare, groupedRowData.compFareSource, groupedRowData.compCarrier, groupedRowData.compTariffNumber, groupedRowData.compTripType, groupedRowData.compMarketFbc, groupedRowData.compFareBrandName, compFare, groupedRowData.compRoutingNumber, groupedRowData.compFootnote, groupedRowData.status, groupedRowData.lastUpdated, getRecommendationReasons(groupedRowData.ladderRemarks), getNoRecommendationReasons(groupedRowData.ladderRemarks), getStopAutoApprovalReasons(groupedRowData.autoApprovalStoppedReasonsFilterKeys)];
  }

  /**
   * Generate adaptive data row
   */
  function getAdaptiveDataRow(rowData, groupedRowData) {
    return [groupedRowData.hostCarrier, rowData.market, rowData.cabin, groupedRowData.season, groupedRowData.dow, groupedRowData.tripTypeCode, groupedRowData.journeyTypeCd, groupedRowData.fareBasisCode, groupedRowData.fareBrandName, rmMomentFormat(groupedRowData.effectiveDate, 'DATE_ISO'), groupedRowData.advancePurchase, groupedRowData.minStays, groupedRowData.maxStay, groupedRowData.routingNumber, groupedRowData.footnote, groupedRowData.constructionMethod, groupedRowData.currencyCode, groupedRowData.currentTotalFare, groupedRowData.currentFareYq, groupedRowData.currentFareYr, groupedRowData.currentFareOther, groupedRowData.currentFareVariable, groupedRowData.currentFareQ, groupedRowData.currentFareQmisc, groupedRowData.effectiveTotalFare, groupedRowData.yq, groupedRowData.yr, groupedRowData.other, groupedRowData.variable, groupedRowData.q, groupedRowData.qmisc, groupedRowData.currentFareBase, groupedRowData.effectiveBaseFare, groupedRowData.fareChangeAbsolute, groupedRowData.fareChangePercentage, groupedRowData.fareBasisCode, groupedRowData.filedTotalFareAmount, groupedRowData.yq, groupedRowData.yr, groupedRowData.other, groupedRowData.variable, groupedRowData.q, groupedRowData.qmisc, groupedRowData.filedFareAmount, groupedRowData.fareBasisCode, groupedRowData.offerFareBrand, groupedRowData.journeyTotalFareAmount, groupedRowData.journeyAmount, groupedRowData.status, rmMomentFormat(groupedRowData.lastUpdated, 'DATE_ISO'), getRecommendationReasons(groupedRowData.ladderRemarks), getNoRecommendationReasons(groupedRowData.ladderRemarks), getStopAutoApprovalReasons(groupedRowData.autoApprovalStoppedReasonsFilterKeys)];
  }

  /**
   * Extract recommendation reasons
   */
  function getRecommendationReasons(ladderRemarks) {
    if (!ladderRemarks || !ladderRemarks.recommendationReasons) {
      return '';
    }
    var reasons = [];
    _.forEach(ladderRemarks.recommendationReasons, function (value, key) {
      reasons.push(key);
    });
    return reasons.join(' | ');
  }

  /**
   * Extract no-recommendation reasons
   */
  function getNoRecommendationReasons(ladderRemarks) {
    if (!ladderRemarks || !ladderRemarks.noRecommendationReasons) {
      return '';
    }
    var reasons = [];
    _.forEach(ladderRemarks.noRecommendationReasons, function (value, key) {
      reasons.push("".concat(key, ":").concat(value));
    });
    return reasons.join(' | ');
  }

  /**
   * Extract stop auto-approval reasons short details
   */
  function getStopAutoApprovalReasons(autoApprovalStoppedReasonsFilterKeys) {
    if (!autoApprovalStoppedReasonsFilterKeys || autoApprovalStoppedReasonsFilterKeys.length === 0 || autoApprovalStoppedReasonsFilterKeys[0] === 'Nil') {
      return '';
    }
    return autoApprovalStoppedReasonsFilterKeys.join(' | ');
  }

  /**
   * Format array as CSV row
   */
  function formatAsCsvRow(stringArrayToFormat) {
    return _.chain(stringArrayToFormat).map(function (value) {
      return "\"".concat(value, "\"");
    }).join(',').value() + '\r\n';
  }

  /**
   * Generate file prefix based on type and market
   */
  function getFilePrefix(type, market) {
    return type === 'all' ? 'Export All FareRecommendation Grids' : "Export FareRecommendation Grid ".concat(market);
  }

  /**
   * Convert row data to CSV format
   */
  function getFileDataFromRows(allRows) {
    return _.reduce(allRows, function (result, row) {
      var formattedRow = _.map(row, formatUndefinedData);
      return result + formatAsCsvRow(formattedRow);
    }, '');
  }

  /**
   * Handle undefined data in CSV
   */
  function formatUndefinedData(field) {
    return field || '';
  }

  /**
   * Main export function for summary CSV format
   */
  function exportToSummaryCSVFormat(data) {
    var _data$, _data$$rowGroups$;
    var rowSortedByRbd = flattendAndSortByRbd(data, app.foCabins, app.seasonDefinitions, app.foRbds);
    var rbds = getAllRbds(rowSortedByRbd);
    var category = (_data$ = data[0]) === null || _data$ === void 0 ? void 0 : (_data$$rowGroups$ = _data$.rowGroups[0]) === null || _data$$rowGroups$ === void 0 ? void 0 : _data$$rowGroups$.category;
    var summaryDataHeader = getSummaryFileColumnHeaders(rbds, category);
    var summaryDataRows = getSummaryFileDataRows(data, rbds, rowSortedByRbd);
    var allRows = _.concat([summaryDataHeader], summaryDataRows);
    if (category === 'ADAPTIVE') {
      allRows = removeColumnsForAdaptive(allRows);
    }
    allRows = removeColumns(allRows);
    fileSaveService.createFile(getFileDataFromRows(allRows), 'text/csv;charset=utf-8', 'Export Summary Report.csv');
  }

  /**
   * Remove specific columns for adaptive data
   */
  function removeColumnsForAdaptive(allRows) {
    var indexesToRemove = [15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 30, 31, 32, 33, 36];
    var indexSet = new Set(indexesToRemove);
    return allRows.map(function (row) {
      return row.filter(function (_, index) {
        return !indexSet.has(index);
      });
    });
  }

  /**
   * Remove unused columns from summary report
   */
  function removeColumns(summaryDataRows) {
    if (!summaryDataRows.length) {
      return summaryDataRows;
    }
    var staticColumns = getSummaryFileColumnTitles();
    var columnsToIgnore = staticColumns.filter(function (col) {
      return col.isRemove === true;
    }).map(function (col) {
      return col.index;
    });
    var columnsToExport = [];
    var headerRow = summaryDataRows[0];

    // Identify columns to keep
    for (var rowIndex = 1; rowIndex < summaryDataRows.length; rowIndex++) {
      var row = summaryDataRows[rowIndex];
      for (var colIndex = 0; colIndex < row.length; colIndex++) {
        if (columnsToIgnore.includes(colIndex)) {
          continue;
        }
        var cellValue = row[colIndex];
        var headerValue = headerRow[colIndex];
        if ((headerValue === null || headerValue === void 0 ? void 0 : headerValue.split('Linked FBC').length) > 1) {
          if (cellValue && cellValue !== '' && cellValue !== faresOptimizerConstants.EN_DASH && !columnsToExport.includes(colIndex)) {
            columnsToExport.push(colIndex);
          }
        } else if (!columnsToExport.includes(colIndex)) {
          columnsToExport.push(colIndex);
        }
      }
    }
    if (columnsToExport.length === 0) {
      return summaryDataRows;
    }
    columnsToExport.sort(function (a, b) {
      return a - b;
    });

    // Create new dataset with only necessary columns
    return summaryDataRows.map(function (row) {
      return columnsToExport.map(function (colIndex) {
        return row[colIndex];
      });
    });
  }

  /**
   * Create season index mapping
   */
  function getSeasonIndexMap(seasonDefinitions) {
    return _.reduce(seasonDefinitions, function (result, seasonDefinition) {
      result[seasonDefinition.season] = seasonDefinition.seasonIndex;
      return result;
    }, {});
  }

  /**
   * Create season abbreviation mapping
   */
  function getFoSeasonAbbreviationMap(seasonDefinitions) {
    return _.reduce(seasonDefinitions, function (result, seasonDefinition) {
      result[seasonDefinition.season] = seasonDefinition.seasonAbbreviation;
      return result;
    }, {});
  }

  /**
   * Flatten and sort data by RBD
   */
  function flattendAndSortByRbd(marketLevelData, foCabins, seasonDefinitions, foRbd) {
    var seasonIndexMap = getSeasonIndexMap(seasonDefinitions);
    var seasonAbbreviationMap = getFoSeasonAbbreviationMap(seasonDefinitions);
    var flattenedRows = decorateAndFlattenToMarketFbcLevel(marketLevelData, foCabins, seasonIndexMap, seasonAbbreviationMap, foRbd);
    return sortForFbcOrder(flattenedRows);
  }

  /**
   * Decorate and flatten market data
   */
  function decorateAndFlattenToMarketFbcLevel(marketLevelData, foCabins, seasonIndexMap, seasonAbbreviationMap, foRbd) {
    var actionCodeDescription = {
      n: 'New Fare',
      c: 'Changed Fare',
      x: 'Cancelled Fare'
    };
    var flattenedRows = [];
    _.forEach(marketLevelData, function (marketLevelRow) {
      var rowGroups = getUnexpiredRecommendations(marketLevelRow.rowGroups);
      _.forEach(rowGroups, function (rowGroup) {
        _.forEach(rowGroup.groupedRows, function (row) {
          // Enhance row with additional properties
          var enhancedRow = _objectSpread(_objectSpread({}, row), {}, {
            exportOrigin: rowGroup.origin,
            exportDestination: rowGroup.destination,
            exportCabin: rowGroup.cabin,
            exportTariffCode: rowGroup.tariffCode,
            exportRoutingNumber: rowGroup.routingNumber,
            exportFootnote: rowGroup.footnote,
            cabinIndex: _.indexOf(foCabins, row.cabin),
            seasonIndex: seasonIndexMap[row.season],
            seasonAbbreviation: seasonAbbreviationMap[row.season],
            classIndex: _.indexOf(foRbd, row.rbd),
            exportCompFareSource: rowGroup.compFareSource,
            exportCompCarrier: rowGroup.compCarrier,
            exportCompAp: rowGroup.compAp,
            exportCompMarketFbc: rowGroup.compMarketFbc,
            exportCompTariffNumber: rowGroup.compTariffNumber,
            exportSeason: rowGroup.season,
            exportActionCode: rowGroup.actionCode ? actionCodeDescription[rowGroup.actionCode.toLowerCase()] : '',
            exportDoW: rowGroup.dow,
            exportCompRoutingNumber: rowGroup.compRoutingNumber,
            exportCompFootnote: rowGroup.compFootnote
          });

          // Handle comp fare details
          if (rowGroup.compFare) {
            var compFareDetails = rowGroup.compFare.split('&nbsp;');
            enhancedRow.exportCompCurrency = compFareDetails[0];
            enhancedRow.exportCompFare = compFareDetails[1];
          }
          flattenedRows.push(enhancedRow);
        });
      });
    });
    return flattenedRows;
  }

  /**
   * Sort by FBC order
   */
  function sortForFbcOrder(flattenedRows) {
    return _.orderBy(flattenedRows, ['classIndex'], ['asc']);
  }

  /**
   * Extract all RBDs
   */
  function getAllRbds(rowSortedByRbd) {
    return _.chain(rowSortedByRbd).groupBy('rbd').transform(function (result, rbdMarketLevelRow) {
      result.push(getRbds(rbdMarketLevelRow));
    }, []).value();
  }

  /**
   * Get RBD information
   */
  function getRbds(rbdMarketLevelRow) {
    return {
      rbd: rbdMarketLevelRow[0].rbd,
      hostCarrier: rbdMarketLevelRow[0].carrier
    };
  }

  /**
   * Generate summary file column headers
   */
  function getSummaryFileColumnHeaders(summaryFileHeaderRawData, category) {
    var columnTitles = getSummaryFileColumnTitles();
    var mergedColumnTitles = category === "ADAPTIVE" ? columnTitles.concat(getAdaptiveSpecificSummaryFileColumnTitles()) : columnTitles;
    var columnHeaderRow = _.map(mergedColumnTitles, 'label');

    // Create column groups
    var columnGroups = {
      fbcColumns: [],
      linkedFbcColumns: [],
      currFareColumns: [],
      linkedFbcCurrFareColumns: [],
      recomFareColumns: [],
      linkedFbcRecomFareColumns: [],
      apColumns: [],
      linkedFbcApColumns: [],
      obBlackoutColumns: [],
      linkedFbcObBlackoutColumns: [],
      ibBlackoutColumns: [],
      linkedFbcIbBlackoutColumns: []
    };

    // Generate column headers for each RBD
    _.forEach(summaryFileHeaderRawData, function (fbcGroupRow) {
      var rbd = fbcGroupRow.rbd;
      var carrier = fbcGroupRow.hostCarrier;
      columnGroups.fbcColumns.push(getFbcColumn(carrier, rbd));
      columnGroups.linkedFbcColumns.push(getFbcColumn(carrier, rbd, true));
      columnGroups.currFareColumns.push(getCurrentFareColumn(rbd));
      columnGroups.linkedFbcCurrFareColumns.push(getCurrentFareColumn(rbd, true));
      columnGroups.recomFareColumns.push(getRecomFareColumn(rbd));
      columnGroups.linkedFbcRecomFareColumns.push(getRecomFareColumn(rbd, true));
      columnGroups.apColumns.push(getApColumn(rbd));
      columnGroups.linkedFbcApColumns.push(getApColumn(rbd, true));
      columnGroups.obBlackoutColumns.push(getObBlackoutColumn(rbd));
      columnGroups.linkedFbcObBlackoutColumns.push(getObBlackoutColumn(rbd, true));
      columnGroups.ibBlackoutColumns.push(getIbBlackoutColumn(rbd));
      columnGroups.linkedFbcIbBlackoutColumns.push(getIbBlackoutColumn(rbd, true));
    });

    // Combine all column groups in order
    return columnHeaderRow.concat(columnGroups.fbcColumns, columnGroups.linkedFbcColumns, ['Currency'], columnGroups.currFareColumns, columnGroups.linkedFbcCurrFareColumns, columnGroups.recomFareColumns, columnGroups.linkedFbcRecomFareColumns, columnGroups.apColumns, columnGroups.linkedFbcApColumns, columnGroups.obBlackoutColumns, columnGroups.linkedFbcObBlackoutColumns, columnGroups.ibBlackoutColumns, columnGroups.linkedFbcIbBlackoutColumns);
  }

  /**
   * Format FBC column header
   */
  function getFbcColumn(carrier, rbd, isLinkedFbcColumn) {
    return carrier + (isLinkedFbcColumn ? " Linked FBC (".concat(rbd, ")") : " FBC (".concat(rbd, ")"));
  }

  /**
   * Format current fare column header
   */
  function getCurrentFareColumn(rbd, isLinkedFbcColumn) {
    return "Curr (".concat(rbd, ")").concat(isLinkedFbcColumn ? ' Linked FBC' : '');
  }

  /**
   * Format recommended fare column header
   */
  function getRecomFareColumn(rbd, isLinkedFbcColumn) {
    return "Recom (".concat(rbd, ")").concat(isLinkedFbcColumn ? ' Linked FBC' : '');
  }

  /**
   * Format AP column header
   */
  function getApColumn(rbd, isLinkedFbcColumn) {
    return "".concat(rbd, "_AP").concat(isLinkedFbcColumn ? ' Linked FBC' : '');
  }

  /**
   * Format outbound blackout column header
   */
  function getObBlackoutColumn(rbd, isLinkedFbcColumn) {
    return "".concat(rbd, "_OB_Blackout").concat(isLinkedFbcColumn ? ' Linked FBC' : '');
  }

  /**
   * Format inbound blackout column header
   */
  function getIbBlackoutColumn(rbd, isLinkedFbcColumn) {
    return "".concat(rbd, "_IB_Blackout").concat(isLinkedFbcColumn ? ' Linked FBC' : '');
  }

  /**
   * Generate summary file data rows
   */
  function getSummaryFileDataRows(data, summaryFileHeaderRawData, rowSortedByRbd) {
    var rbdColumns = _.map(summaryFileHeaderRawData, 'rbd');

    // Add unique row identifiers
    populateMarketRoutingTariffFootnote(data, rowSortedByRbd);

    // Filter to unique rows only
    var uniqueRows = _.filter(rowSortedByRbd, 'uniqueRow');

    // Generate FBC market fare map
    var fbcMarketFareMap = getFbcMarketFareMap(uniqueRows);

    // Get unique markets as base for summary rows
    var summaryFileDataRows = getUniqueMarkets(data, uniqueRows);

    // Populate columns with data
    var columnsToPopulate = ['fbc', 'linkedFbc', 'currency', 'currFare', 'linkedFbcCurrFare', 'effFare', 'linkedFbcEffFare', 'ap', 'linkedFbcAp', 'obBlackoutDates', 'linkedFbcObBlackoutDates', 'ibBlackoutDates', 'linkedFbcIbBlackoutDates'];

    // Populate each column type
    columnsToPopulate.forEach(function (column) {
      summaryFileDataRows = populateSummaryFileGridDataRows(summaryFileDataRows, rbdColumns, fbcMarketFareMap, column);
    });
    return summaryFileDataRows;
  }

  /**
   * Process linked FBC fare map
   */
  function getLinkedFbcFareMap(row, key, result) {
    // Initialize or use existing result object
    result[key] = result[key] || {};

    // Update linked FBC current fare
    var existingLinkedFbcBaseFare = result[key].linkedFbcCurrFare || 0;
    result[key].linkedFbcCurrFare = Math.round(Math.max(existingLinkedFbcBaseFare, row.currentFareBase));

    // Update linked FBC effective fare
    var existingLinkedFbcEffectiveBaseFare = result[key].linkedFbcEffFare || 0;
    result[key].linkedFbcEffFare = Math.round(Math.max(existingLinkedFbcEffectiveBaseFare, row.effectiveBaseFare));

    // Set other linked FBC properties
    result[key].linkedFbc = row.fbc;
    result[key].linkedFbcAp = row.ap;
    result[key].linkedFbcObBlackoutDates = pickAllDates(row.outboundBlackouts);
    result[key].linkedFbcIbBlackoutDates = pickAllDates(row.inboundBlackouts);

    // Ensure regular properties exist
    result[key].currFare = result[key].currFare || '';
    result[key].effFare = result[key].effFare || '';
    result[key].fbc = result[key].fbc || '';
    result[key].ap = result[key].ap || '';
    result[key].obBlackoutDates = result[key].obBlackoutDates || '';
    result[key].ibBlackoutDates = result[key].ibBlackoutDates || '';
  }

  /**
   * Process regular FBC fare map
   */
  function getFbcFareMap(row, key, result) {
    // Initialize or use existing result object
    result[key] = result[key] || {};

    // Update regular current fare
    var existingBaseFare = result[key].currFare || 0;
    result[key].currFare = Math.round(Math.max(existingBaseFare, row.currentFareBase));

    // Update regular effective fare
    var existingEffectiveBaseFare = result[key].effFare || 0;
    result[key].effFare = Math.round(Math.max(existingEffectiveBaseFare, row.effectiveBaseFare));

    // Set other regular properties
    result[key].fbc = row.fbc;
    result[key].ap = row.ap;
    result[key].obBlackoutDates = pickAllDates(row.outboundBlackouts);
    result[key].ibBlackoutDates = pickAllDates(row.inboundBlackouts);

    // Ensure linked properties exist
    result[key].linkedFbcCurrFare = result[key].linkedFbcCurrFare || '';
    result[key].linkedFbcEffFare = result[key].linkedFbcEffFare || '';
    result[key].linkedFbc = result[key].linkedFbc || '';
    result[key].linkedFbcAp = result[key].linkedFbcAp || '';
    result[key].linkedFbcObBlackoutDates = result[key].linkedFbcObBlackoutDates || '';
    result[key].linkedFbcIbBlackoutDates = result[key].linkedFbcIbBlackoutDates || '';
  }

  /**
   * Create FBC market fare map
   */
  function getFbcMarketFareMap(rowSortedByRbd) {
    return _.reduce(rowSortedByRbd, function (result, row) {
      // Create a unique key for this row
      var key = _.join([row.market, row.cabin, row.rbd, row.routingNumber, row.tariffCode, row.exportSeason, row.exportCompCarrier, row.fbc, row.isLinkedFbc, row.tripType, row.footnote], ':');

      // Process based on whether it's linked FBC or not
      row.isLinkedFbc ? getLinkedFbcFareMap(row, key, result) : getFbcFareMap(row, key, result);

      // Store currency for later use
      result.exportHostCurrency = row.currencyCode;
      return result;
    }, {});
  }

  /**
   * Add unique row identifiers
   */
  function populateMarketRoutingTariffFootnote(data, rowSortedByRbd) {
    _.forEach(rowSortedByRbd, function (row) {
      if (row.exportSeason !== undefined) {
        row.uniqueRow = _.join([row.origin, row.destination, row.cabin, row.fbc, row.routingNumber, row.tariffCode, row.exportSeason, row.exportCompCarrier, row.isLinkedFbc, row.tripType, row.footnote], '-');
      }
    });
  }

  /**
   * Extract unique markets for summary
   */
  function getUniqueMarkets(data, rowSortedByRbd) {
    var _data$2, _data$2$rowGroups$;
    var category = (_data$2 = data[0]) === null || _data$2 === void 0 ? void 0 : (_data$2$rowGroups$ = _data$2.rowGroups[0]) === null || _data$2$rowGroups$ === void 0 ? void 0 : _data$2$rowGroups$.category;
    var columnTitles = getSummaryFileColumnTitles();
    var mergedColumnTitles = category === "ADAPTIVE" ? columnTitles.concat(getAdaptiveSpecificSummaryFileColumnTitles()) : columnTitles;
    var columnFields = _.map(mergedColumnTitles, 'field');
    var clonedRows = _.cloneDeep(rowSortedByRbd);
    return _.chain(clonedRows).groupBy('uniqueRow').map(function (row) {
      return _.transform(columnFields, function (result, fieldName) {
        var fieldValue = row[0][fieldName];

        // Format date fields
        if (fieldName.includes('Date') || fieldName === 'ticketingDates' || fieldName === 'reservationDates' || fieldName === 'outboundTravelDates' || fieldName === 'inboundTravelDates' || fieldName === 'outboundSeasons' || fieldName === 'inboundSeasons') {
          var hasFromToCompleteDates = fieldName === 'outboundTravelDates' || fieldName === 'inboundTravelDates';
          fieldValue = pickAllDates(fieldValue, hasFromToCompleteDates);
        } else if (fieldName === 'recommendationReasons') {
          fieldValue = getRecommendationReasons(row[0]['ladderRemarks']);
        } else if (fieldName === 'noRecommendationReasons') {
          fieldValue = getNoRecommendationReasons(row[0]['ladderRemarks']);
        } else if (fieldName === 'autoApprovalStoppedReasonsFilterKeys') {
          fieldValue = getStopAutoApprovalReasons(row[0]['autoApprovalStoppedReasonsFilterKeys']);
        } else if (fieldName === 'lastUpdated') {
          fieldValue = rmMomentFormat(row[0]['lastUpdated'], 'DATE_ISO');
        }
        result.push(fieldValue);
      }, []);
    }).value();
  }

  /**
   * Format date values for display
   */
  function pickAllDates(dateDetails) {
    var hasFromToCompleteDates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (!dateDetails) {
      return '';
    }

    // Handle single moment
    if (momentService.isMoment(dateDetails)) {
      return rmMomentFormat(dateDetails, momentConstants.DAY_MONTH_YEAR);
    }

    // Handle array of date ranges
    if (Array.isArray(dateDetails)) {
      var formattedDates = dateDetails.map(function (eachDate) {
        var strDate = '';

        // Format begin/from date
        if (eachDate.begin || eachDate.from) {
          strDate = formatDateData(eachDate.begin || eachDate.from);
        }
        strDate += '-';

        // Format end/to date
        if (eachDate.end || eachDate.to) {
          strDate += formatDateData(eachDate.end || eachDate.to);
        }

        // Format complete date if needed
        if (hasFromToCompleteDates) {
          strDate += '-';
          if (eachDate.complete) {
            strDate += formatDateData(eachDate.complete);
          }
        }
        return strDate;
      });
      return formattedDates.length > 0 ? formattedDates.join(' | ') : '';
    }

    // Handle single date object
    return formatDateData(dateDetails);
  }

  /**
   * Format date data consistently
   */
  function formatDateData(data) {
    if (_.isEmpty(data)) {
      return '';
    }
    return rmMomentFormat(momentService.of(data, momentService.FIELD.OPT_GROUP_DATE), momentConstants.DAY_MONTH_YEAR);
  }

  /**
   * Populate summary file grid data rows
   */
  function populateSummaryFileGridDataRows(summaryFileDataRows, rbdColumns, fbcMarketFareMap, columnName) {
    return summaryFileDataRows.map(function (marketRow) {
      var newRow = (0, _toConsumableArray2["default"])(marketRow);
      if (columnName === 'currency') {
        // Add currency column
        newRow.push(fbcMarketFareMap.exportHostCurrency);
      } else {
        // Add data for each RBD
        rbdColumns.forEach(function (rbd) {
          // Create key for looking up data
          var keyParts = [marketRow[3] + '-' + marketRow[4],
          // market
          marketRow[5],
          // cabin
          rbd,
          // rbd
          marketRow[9] ? marketRow[9].trim() : '',
          // routing
          marketRow[7] ? marketRow[7].trim() : '',
          // tariff
          marketRow[29] ? marketRow[29] : '',
          // season
          marketRow[21] ? marketRow[21].trim() : '',
          // comp carrier
          marketRow[40] ? marketRow[40].trim() : '',
          // fbc
          marketRow[41],
          // isLinkedFbc
          marketRow[37],
          // tripType
          marketRow[12] ? marketRow[12].trim() : '' // footnote
          ];
          var key = keyParts.join(':');
          var keyWithFbc = key + ':' + (marketRow[41] ? marketRow[40] : '');

          // Get data for this column
          var value = fbcMarketFareMap[keyWithFbc] && fbcMarketFareMap[keyWithFbc][columnName] || fbcMarketFareMap[key] && fbcMarketFareMap[key][columnName] || '';
          newRow.push(value);
        });
      }
      return newRow;
    });
  }

  /**
   * Get structural header metadata
   */
  function getStructuralHeaderMetadata() {
    return [{
      field: 'hostCarrier',
      label: 'Host Carrier'
    }, {
      field: 'market',
      label: 'Market'
    }, {
      field: 'cabin',
      label: 'Cabin'
    }, {
      field: "tariffNumber",
      label: "Host Tariff Number"
    }, {
      field: 'season',
      label: 'Season'
    }, {
      field: 'dow',
      label: 'DOW'
    }, {
      field: 'tripType',
      label: 'Fare Type Indicator'
    }, {
      field: 'fbc',
      label: 'FBC'
    }, {
      field: 'fareBrandName',
      label: 'Host Fare Brand'
    }, {
      field: 'effDate',
      label: 'Eff Date'
    }, {
      field: 'discDate',
      label: 'Disc Date'
    }, {
      field: 'advancePurchase',
      label: 'Rec. AP'
    }, {
      field: 'apGroup',
      label: 'AP Group'
    }, {
      field: 'minStays',
      label: 'Min Stay'
    }, {
      field: 'maxStay',
      label: 'Max Stay'
    }, {
      field: 'routingNumber',
      label: 'Routing Number'
    }, {
      field: 'footnote',
      label: 'Footnote'
    }, {
      filed: 'constructionMethod',
      label: 'Cons'
    }, {
      field: 'hostCurrency',
      label: 'Host Currency'
    }, {
      field: 'totalFareCurrent',
      label: 'Total Fare Current'
    }, {
      field: 'totalFareRecommended',
      label: 'Total Fare Recommended'
    }, {
      field: 'fareChangeA',
      label: 'Fare Change A'
    }, {
      field: 'fareChangeP',
      label: 'Fare Change P'
    }, {
      field: 'fareChangeD',
      label: 'Fare Change D'
    }, {
      field: 'baseFareCurrent',
      label: 'Base Fare Current'
    }, {
      field: 'baseFareRecommended',
      label: 'Base Fare Recommended'
    }, {
      field: 'baseFareDistributed',
      label: 'Base Fare Distributed'
    }, {
      field: 'compFareSource',
      label: 'Competitor Fare Source'
    }, {
      field: 'compMatchAirline',
      label: 'Competitor Airline'
    }, {
      field: "compTariffNumber",
      label: "Competitor Tariff Number"
    }, {
      field: 'compTripType',
      label: 'Competitor Fare Type Indicator'
    }, {
      field: 'compMatchFBC',
      label: 'Competitor FBC'
    }, {
      field: 'compFareBrandName',
      label: 'Competitor Fare Brand'
    }, {
      field: 'compMatchFare',
      label: 'Competitor Fare'
    }, {
      field: 'compRoutingNumber',
      label: 'Competitor Routing Number'
    }, {
      field: 'compMatchFootnote',
      label: 'Competitor Foot Note'
    }, {
      field: 'status',
      label: 'Status'
    }, {
      field: 'lastUpdated',
      label: 'Last Updated'
    }, {
      field: 'recommendationReasons',
      label: 'Reasons for Recommendation'
    }, {
      field: 'noRecommendationReasons',
      label: 'Reasons for Failure'
    }, {
      field: 'autoApprovalStoppedReasonsFilterKeys',
      label: 'Reasons for Stop Auto Approval'
    }];
  }

  /**
   * Get tactical header metadata
   */
  function getTacticalHeaderMetadata() {
    return [{
      field: 'hostCarrier',
      label: 'Host Carrier'
    }, {
      field: 'market',
      label: 'Market'
    }, {
      field: 'cabin',
      label: 'Cabin'
    }, {
      field: "tariffNumber",
      label: "Host Tariff Number"
    }, {
      field: 'season',
      label: 'Season'
    }, {
      field: 'dow',
      label: 'DOW'
    }, {
      field: 'tripType',
      label: 'Fare Type Indicator'
    }, {
      field: 'fbc',
      label: 'FBC'
    }, {
      field: 'fareBrandName',
      label: 'Host Fare Brand'
    }, {
      field: 'effDate',
      label: 'Eff Date'
    }, {
      field: 'discDate',
      label: 'Disc Date'
    }, {
      field: 'advancePurchase',
      label: 'Rec. AP'
    }, {
      field: 'apGroup',
      label: 'AP Group'
    }, {
      field: 'minStays',
      label: 'Min Stay'
    }, {
      field: 'maxStay',
      label: 'Max Stay'
    }, {
      field: 'routingNumber',
      label: 'Routing Number'
    }, {
      field: 'footnote',
      label: 'Footnote'
    }, {
      filed: 'constructionMethod',
      label: 'Cons'
    }, {
      field: 'firstTicketDate',
      label: 'First Ticket'
    }, {
      field: 'lastTicketDate',
      label: 'Last Ticket'
    }, {
      field: 'travelFromDate',
      label: 'Travel From'
    }, {
      field: 'travelToDate',
      label: 'Travel To'
    }, {
      field: 'travelCompleteDate',
      label: 'Travel Complete'
    }, {
      field: 'hostCurrency',
      label: 'Host Currency'
    }, {
      field: 'totalFareCurrent',
      label: 'Total Fare Current'
    }, {
      field: 'totalFareRecommended',
      label: 'Total Fare Recommended'
    }, {
      field: 'fareChangeA',
      label: 'Fare Change A'
    }, {
      field: 'fareChangeP',
      label: 'Fare Change P'
    }, {
      field: 'fareChangeD',
      label: 'Fare Change D'
    }, {
      field: 'baseFareCurrent',
      label: 'Base Fare Current'
    }, {
      field: 'baseFareRecommended',
      label: 'Base Fare Recommended'
    }, {
      field: 'baseFareDistributed',
      label: 'Base Fare Distributed'
    }, {
      field: 'compFareSource',
      label: 'Competitor Fare Source'
    }, {
      field: 'compMatchAirline',
      label: 'Competitor Airline'
    }, {
      field: "compTariffNumber",
      label: "Competitor Tariff Number"
    }, {
      field: 'compTripType',
      label: 'Competitor Fare Type Indicator'
    }, {
      field: 'compMatchFBC',
      label: 'Competitor FBC'
    }, {
      field: 'compFareBrandName',
      label: 'Competitor Fare Brand'
    }, {
      field: 'compMatchFare',
      label: 'Competitor Fare'
    }, {
      field: 'compRoutingNumber',
      label: 'Competitor Routing Number'
    }, {
      field: 'compMatchFootnote',
      label: 'Competitor Foot Note'
    }, {
      field: 'status',
      label: 'Status'
    }, {
      field: 'lastUpdated',
      label: 'Last Updated'
    }, {
      field: 'recommendationReasons',
      label: 'Reasons for Recommendation'
    }, {
      field: 'noRecommendationReasons',
      label: 'Reasons for Failure'
    }, {
      field: 'autoApprovalStoppedReasonsFilterKeys',
      label: 'Reasons for Stop Auto Approval'
    }];
  }

  /**
   * Get adaptive header metadata
   */
  function getAdaptiveHeaderMetadata() {
    return [{
      field: 'hostCarrier',
      label: 'Host Carrier'
    }, {
      field: 'market',
      label: 'Market'
    }, {
      field: 'cabin',
      label: 'Cabin'
    }, {
      field: 'season',
      label: 'Season'
    }, {
      field: 'dow',
      label: 'DOW'
    }, {
      field: 'tripTypeCode',
      label: 'OW/RT'
    }, {
      field: 'journeyTypeCd',
      label: 'OB/IB'
    }, {
      field: 'fareBasisCode',
      label: 'FBC'
    }, {
      field: 'fareBrandName',
      label: 'Host Fare Brand'
    }, {
      field: 'effectiveDate',
      label: 'Eff Date'
    }, {
      field: 'advancePurchase',
      label: 'AP'
    }, {
      field: 'minStays',
      label: 'Min'
    }, {
      field: 'maxStay',
      label: 'Max'
    }, {
      field: 'routingNumber',
      label: 'Routing Number'
    }, {
      field: 'footnote',
      label: 'Footnote'
    }, {
      filed: 'constructionMethod',
      label: 'Cons'
    }, {
      field: 'currencyCode',
      label: 'Host Currency'
    }, {
      field: 'currentTotalFare',
      label: 'Total Fare Current'
    }, {
      field: 'currentFareYq',
      label: 'Total Fare Current YQ'
    }, {
      field: 'currentFareYr',
      label: 'Total Fare Current YR'
    }, {
      field: 'currentFareOther',
      label: 'Total Fare Current Airport Tax'
    }, {
      field: 'currentFareVariable',
      label: 'Total Fare Current Variable Tax'
    }, {
      field: 'currentFareQ',
      label: 'Total Fare Current Fuel Surcharge'
    }, {
      field: 'currentFareQmisc',
      label: 'Total Fare Current Cat12 Surcharge'
    }, {
      field: 'effectiveTotalFare',
      label: 'Total Fare Eff'
    }, {
      field: 'yq',
      label: 'Total Fare Eff YQ'
    }, {
      field: 'yr',
      label: 'Total Fare Eff YR'
    }, {
      field: 'other',
      label: 'Total Fare Eff Airport Tax'
    }, {
      field: 'variable',
      label: 'Total Fare Eff Variable Tax'
    }, {
      field: 'q',
      label: 'Total Fare Eff Fuel Surcharge'
    }, {
      field: 'qmisc',
      label: 'Total Fare Eff Cat12 Surcharge'
    }, {
      field: 'currentFareBase',
      label: 'Base Fare Current'
    }, {
      field: 'effectiveBaseFare',
      label: 'Base Fare Eff'
    }, {
      field: 'fareChangeAbsolute',
      label: 'Fare Change Absolute'
    }, {
      field: 'fareChangePercentage',
      label: 'Fare Change Percentage'
    }, {
      field: 'fareBasisCode',
      label: 'Comparable GDS Fare FBC'
    }, {
      field: 'filedTotalFareAmount',
      label: 'Comparable GDS Fare Amount'
    }, {
      field: 'yq',
      label: 'Comparable GDS Fare Amount YQ'
    }, {
      field: 'yr',
      label: 'Comparable GDS Fare Amount YQ'
    }, {
      field: 'other',
      label: 'Comparable GDS Fare Amount Airport Tax'
    }, {
      field: 'variable',
      label: 'Comparable GDS Fare Amount Variable Tax'
    }, {
      field: 'q',
      label: 'Comparable GDS Fare Amount Fuel Surcharge'
    }, {
      field: 'qmisc',
      label: 'Comparable GDS Fare Amount Cat12 Surcharge'
    }, {
      field: 'filedFareAmount',
      label: 'Comparable GDS Base Fare'
    }, {
      field: 'fareBasisCode',
      label: 'Offer Price FBC'
    }, {
      field: 'offerFareBrand',
      label: 'Offer Price Fare Brand'
    }, {
      field: 'journeyTotalFareAmount',
      label: 'Offer Price Total Fare'
    }, {
      field: 'journeyAmount',
      label: 'Offer Price base Fare'
    }, {
      field: 'status',
      label: 'Status'
    }, {
      field: 'lastUpdated',
      label: 'Last Updated'
    }, {
      field: 'recommendationReasons',
      label: 'Reasons for Recommendation'
    }, {
      field: 'noRecommendationReasons',
      label: 'Reasons for Failure'
    }, {
      field: 'autoApprovalStoppedReasonsFilterKeys',
      label: 'Reasons for Stop Auto Approval'
    }];
  }

  /**
   * Get summary file column titles
   */
  function getSummaryFileColumnTitles() {
    return [{
      field: 'hostCarrier',
      label: 'Host Carrier',
      index: 0
    }, {
      field: 'exportOrigin',
      label: 'ORI',
      index: 1
    }, {
      field: 'exportDestination',
      label: 'DES',
      index: 2
    }, {
      field: 'origin',
      label: 'ORI',
      isRemove: true,
      index: 3
    }, {
      field: 'destination',
      label: 'DES',
      isRemove: true,
      index: 4
    }, {
      field: 'cabin',
      label: 'Cabin',
      isRemove: true,
      index: 5
    }, {
      field: 'exportCabin',
      label: 'Cabin',
      index: 6
    }, {
      field: 'tariffCode',
      label: 'Tariff Number',
      isRemove: true,
      index: 7
    }, {
      field: 'exportTariffCode',
      label: 'Tariff Number',
      index: 8
    }, {
      field: 'routingNumber',
      label: 'Routing Number',
      isRemove: true,
      index: 9
    }, {
      field: 'exportRoutingNumber',
      label: 'Routing Number',
      index: 10
    }, {
      field: 'exportFootnote',
      label: 'Footnote',
      index: 11
    }, {
      field: 'footnote',
      label: 'Footnote',
      isRemove: true,
      index: 12
    }, {
      field: 'status',
      label: 'Status',
      index: 13
    }, {
      field: 'exportActionCode',
      label: 'Recommendation Type',
      index: 14
    }, {
      field: 'firstTicketDate',
      label: 'First Ticket Date',
      index: 15
    }, {
      field: 'lastTicketDate',
      label: 'Last Ticket Date',
      index: 16
    }, {
      field: 'travelFromDate',
      label: 'Travel From Date',
      index: 17
    }, {
      field: 'travelToDate',
      label: 'Travel To Date',
      index: 18
    }, {
      field: 'travelCompleteDate',
      label: 'Travel Completion Date',
      index: 19
    }, {
      field: 'exportCompFareSource',
      label: 'Comp Fare Source',
      index: 20
    }, {
      field: 'exportCompCarrier',
      label: 'Entry Level BMA',
      index: 21
    }, {
      field: 'exportCompTariffNumber',
      label: 'Competitor Tariff Number',
      index: 22
    }, {
      field: 'exportCompMarketFbc',
      label: 'Comp FBC',
      index: 23
    }, {
      field: 'exportCompCurrency',
      label: 'Comp Currency',
      index: 24
    }, {
      field: 'exportCompFare',
      label: 'Comp total Fare',
      index: 25
    }, {
      field: 'exportCompRoutingNumber',
      label: 'Comp Routing',
      index: 26
    }, {
      field: 'exportCompFootnote',
      label: 'Comp Footnote',
      index: 27
    }, {
      field: 'exportCompAp',
      label: 'Comp AP',
      index: 28
    }, {
      field: 'exportSeason',
      label: 'Season',
      index: 29
    }, {
      field: 'ticketingDates',
      label: 'Ticketing Dates',
      index: 30
    }, {
      field: 'reservationDates',
      label: 'Sale Dates',
      index: 31
    }, {
      field: 'outboundTravelDates',
      label: 'OB Travel Restriction',
      index: 32
    }, {
      field: 'inboundTravelDates',
      label: 'IB Travel Restriction',
      index: 33
    }, {
      field: 'outboundSeasons',
      label: 'OB Season',
      index: 34
    }, {
      field: 'inboundSeasons',
      label: 'IB Season',
      index: 35
    }, {
      field: 'daysOfWeek',
      label: 'Comp DOW',
      index: 36
    }, {
      field: 'tripType',
      label: 'Trip Type',
      index: 37
    }, {
      field: 'exportDoW',
      label: 'DoW',
      index: 38
    }, {
      field: 'hostEntryLevelFbc',
      label: 'Host Entry Level FBC',
      index: 39
    }, {
      field: 'fbc',
      label: 'FBC',
      index: 40
    }, {
      field: 'isLinkedFbc',
      label: 'Linked FBC',
      index: 41
    }, {
      field: 'category',
      label: 'Category',
      index: 42
    }, {
      field: 'recommendationReasons',
      label: 'Reasons for Recommendation',
      index: 43
    }, {
      field: 'noRecommendationReasons',
      label: 'Reasons for Failure',
      index: 44
    }, {
      field: 'autoApprovalStoppedReasonsFilterKeys',
      label: 'Reasons for Stop Auto Approval',
      index: 45
    }, {
      field: 'lastUpdated',
      label: 'Last Updated',
      index: 46
    }];
  }

  /**
   * Get additional adaptive-specific summary file column titles
   */
  function getAdaptiveSpecificSummaryFileColumnTitles() {
    return [{
      field: 'fareBasisCode',
      label: 'Comparable GDS Fare FBC'
    }, {
      field: 'filedTotalFareAmount',
      label: 'Comparable GDS Fare Amount'
    }, {
      field: 'filedFareAmount',
      label: 'Comparable GDS Base Fare'
    }, {
      field: 'fareBasisCode',
      label: 'Offer Price FBC'
    }, {
      field: 'offerFareBrand',
      label: 'Offer Price Fare Brand'
    }, {
      field: 'journeyTotalFareAmount',
      label: 'Offer Price Total Fare'
    }, {
      field: 'journeyAmount',
      label: 'Offer Price base Fare'
    }];
  }

  // Public API
  return {
    exportToCSVFormat: exportToCSVFormat,
    exportToSummaryCSVFormat: exportToSummaryCSVFormat
  };
};
FaresOptimizerCSVExportService.$inject = ['$filter', 'FileSaveService', 'App', 'FaresOptimizerConstants', 'MomentService', 'MomentConstants'];
module.exports = FaresOptimizerCSVExportService;